const API_BASE = process.env.REACT_APP_API_BASE || 'https://func-clara-demo.azurewebsites.net/api';
const API_KEY = process.env.REACT_APP_API_KEY || '';

async function apiFetch(path: string, options: RequestInit = {}) {
  const url = `${API_BASE}${path}`;
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (API_KEY) headers['x-functions-key'] = API_KEY;
  const res = await fetch(url, {
    ...options,
    headers: { ...headers, ...(options.headers as Record<string, string> || {}) },
  });
  if (!res.ok) throw new Error(`API ${res.status}: ${await res.text()}`);
  return res.json();
}

export async function getCurrentUser(): Promise<{ userId: string; userDetails: string; userRoles: string[]; displayName: string }> {
  const res = await fetch('/.auth/me');
  const data = await res.json();
  const principal = data.clientPrincipal;
  if (!principal) return { userId: '', userDetails: '', userRoles: [], displayName: '' };

  const email = principal.userDetails || '';
  let displayName = email.split('@')[0] || '';

  // Fetch real name from backend
  try {
    const separator = API_KEY ? '&' : '';
    const profileRes = await fetch(`${API_BASE}/user-profile?upn=${encodeURIComponent(email)}${API_KEY ? `${separator}code=${API_KEY}` : ''}`);
    const profile = await profileRes.json();
    if (profile.displayName) displayName = profile.displayName;
  } catch {}

  return {
    userId: principal.userId,
    userDetails: email,
    userRoles: principal.userRoles || [],
    displayName,
  };
}

export const api = {
  getRequests: (status?: string) =>
    apiFetch(`/uservoice/requests${status ? `?status=${status}` : ''}`),

  submitRequest: (text: string, submittedBy: string, submittedByUpn: string) =>
    apiFetch('/uservoice/requests', {
      method: 'POST',
      body: JSON.stringify({ text, submittedBy, submittedByUpn }),
    }),

  vote: (requestId: string, userId: string) =>
    apiFetch('/uservoice/vote', {
      method: 'POST',
      body: JSON.stringify({ requestId, userId }),
    }),

  updateStatus: (requestId: string, status: string) =>
    apiFetch('/uservoice/status', {
      method: 'POST',
      body: JSON.stringify({ requestId, status }),
    }),
};
